import { render, staticRenderFns } from "./trifle-info.vue?vue&type=template&id=a0c7814e&scoped=true&"
import script from "./trifle-info.vue?vue&type=script&lang=js&"
export * from "./trifle-info.vue?vue&type=script&lang=js&"
import style0 from "./trifle-info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./trifle-info.vue?vue&type=style&index=1&id=a0c7814e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c7814e",
  null
  
)

export default component.exports